import {useCallback, useState} from 'react';
import {jobIncreaseRunLimit} from '../../api/callable/jobs';

export default function useIncreaseJobRunLimit() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const increaseJobRunLimit = useCallback(async (id: string, amount: number) => {
    setLoading(true);
    setError(undefined);
    try {
      return await jobIncreaseRunLimit({id, increaseBy: amount});
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err));
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return {increaseJobRunLimit, loading, error};
}
